export const getTaxLabel = (currencySymbol: string | undefined) => {
  const vatCurrencySymbols = ["€", "£"];

  if (currencySymbol && vatCurrencySymbols.includes(currencySymbol)) {
    return "VAT";
  }
  return "tax";
};

export const formatCurrency = (amount: number, currencyCode: string) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
